export const WIDGET_POSITIONS = ['bottom-right', 'bottom-left', 'top-right', 'top-left'];
export const DEFAULT_WIDGET_POSITION = 'bottom-right';
// Distance (px) between the viewport edge and the trigger button.
export const TRIGGER_EDGE_OFFSET = 16;
// Parses the `data-position` script attribute. Unknown or missing values fall back to the default.
export function parseWidgetPosition(value) {
    var _a;
    const normalized = value === null || value === void 0 ? void 0 : value.trim().toLowerCase();
    return (_a = WIDGET_POSITIONS.find((p) => p === normalized)) !== null && _a !== void 0 ? _a : DEFAULT_WIDGET_POSITION;
}
export function isLeft(position) {
    return position.endsWith('left');
}
export function isTop(position) {
    return position.startsWith('top');
}
// Tailwind classes are spelled out in full so the compiler can detect them.
// Trigger button group, anchored to the chosen corner. The row is reversed on the left so the
// main button stays in the corner and the expand button sits on its inner side.
export const TRIGGER_POSITION_CLASSES = {
    'bottom-right': 'right-4 bottom-4 items-end flex-row',
    'bottom-left': 'left-4 bottom-4 items-end flex-row-reverse',
    'top-right': 'right-4 top-4 items-start flex-row',
    'top-left': 'left-4 top-4 items-start flex-row-reverse',
};
// Popup panel: full width on mobile, 360px and pinned to the chosen side from `md` up.
// It sits just past the trigger button (48px button + 16px edge offset + 12px gap).
export const PANEL_POSITION_CLASSES = {
    'bottom-right': 'bottom-[76px] right-3 left-3 md:left-auto',
    'bottom-left': 'bottom-[76px] right-3 left-3 md:right-auto',
    'top-right': 'top-[76px] right-3 left-3 md:left-auto',
    'top-left': 'top-[76px] right-3 left-3 md:right-auto',
};
// Aligns the 360px card inside the panel container on desktop.
export const PANEL_CARD_ALIGN_CLASSES = {
    'bottom-right': 'ml-auto',
    'bottom-left': 'mr-auto',
    'top-right': 'ml-auto',
    'top-left': 'mr-auto',
};
